import MoreVertIcon from '@mui/icons-material/MoreVert';
import { Box, IconButton, IconButtonProps, Popover, Tooltip } from '@mui/material';
import { ReactNode, useState } from 'react';

export const OverflowActionMenu = ({
  children,
  size = 'small',
}: {
  children: ReactNode;
  size?: IconButtonProps['size'];
}) => {
  const [anchorElement, setAnchorElement] = useState<HTMLElement | undefined>();
  const [hasOpened, setHasOpened] = useState(false);

  const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    setHasOpened(true);
    setAnchorElement(event.currentTarget);
  };

  return (
    <>
      <Tooltip title='More actions'>
        <IconButton onClick={handleOpen} size={size} data-testid='overflow-action-menu-button'>
          <MoreVertIcon sx={{ fontSize: '22px' }} />
        </IconButton>
      </Tooltip>
      <Popover
        open={Boolean(anchorElement)}
        anchorEl={anchorElement}
        onClose={() => setAnchorElement(undefined)}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        transformOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        keepMounted={hasOpened}
      >
        <Box
          data-testid='overflow-action-menu'
          onClick={event => event.stopPropagation()}
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'stretch',
            padding: 0.5,
            '& .MuiButton-root': { justifyContent: 'flex-start', textTransform: 'none', paddingX: 1.5 },
          }}
        >
          {children}
        </Box>
      </Popover>
    </>
  );
};
